import React from 'react';
import PublicPage from './PublicPage';
import LandingPreLogin from './pages/LandingPreLogin';
import SecurityAndFraud from './pages/SecurityAndFraud';
import PublicHelp from './pages/PublicHelp';
import LegalDocument from './pages/LegalDocument';

export const HomePage = () => <PublicPage><LandingPreLogin /></PublicPage>;
export const SecurityPage = ({ isEnglish = false }) => <PublicPage><SecurityAndFraud isEnglish={isEnglish} /></PublicPage>;
export const HelpPage = () => <PublicPage><PublicHelp /></PublicPage>;
export const LegalPage = ({ kind }) => <PublicPage><LegalDocument kind={kind} /></PublicPage>;
